import axios from 'axios';
import { generateUrl, tenantId } from '../helper';
const interview = axios.create({
    baseURL: generateUrl('interview_system'),
});

interview.interceptors.request.use(
    function (config) {
        let token = localStorage.getItem('token');
        if (token && token !== null) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (tenantId && tenantId !== 'undefined' && tenantId !== 'null') {
            config.headers['x-tenant-id'] = tenantId;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

interview.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default interview;
